import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../styles/payments.css";
import Loading from "../helpers/loading_component.js";
import emailjs from "@emailjs/browser";
import { secretKey } from "../.././data";
import SelectSearch from "react-select-search";
import Select from "react-select";

const MySwal = withReactContent(Swal2);

const AddClientSygnPopup = (props) => {
  const [sygn, setSygn] = useState("");
  const [court, setCourt] = useState("");
  const [add, setAdd] = useState(false);
  const [sygnDate, setSygnDate] = useState(
    new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1 < 10
        ? "0" + (new Date().getMonth() + 1)
        : new Date().getMonth() + 1) +
      "-" +
      (new Date().getDate() < 10
        ? "0" + new Date().getDate()
        : new Date().getDate())
  );
  const [loading, setLoading] = useState(true);
  const [courtOptions, setCourtOptions] = useState([]);

  const fetchClientSygn = async () => {
    var body = {
      clientId: +props.clientId,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getSygnClientId", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.length > 0) {
          var sorted = data.sort(function (a, b) {
            return new Date(b.date) - new Date(a.date);
          });
          setSygn(sorted[0].sygn);
          setCourt(sorted[0].court);
          setLoading(false);
        } else {
          setLoading(false);
        }
      })
      .catch((error) => {});
  };

  const getData = async () => {
    setLoading(true);
    await fetchClientSygn();
    setCourtOptions(createCourtOptions());
  };

  useEffect(() => {
    getData();
  }, []);

  const handleSygnChange = (e) => {
    setSygn(e.target.value);
  };

  const handleSygnDateChange = (e) => {
    setSygnDate(e.target.value);
  };

  const addSygn = async (e) => {
    if (validateSygn()) {
      setLoading(true);

      var date =
        new Date(sygnDate).getFullYear() +
        "-" +
        (new Date(sygnDate).getMonth() + 1 < 10
          ? "0" + (new Date(sygnDate).getMonth() + 1)
          : new Date(sygnDate).getMonth() + 1) +
        "-" +
        (new Date(sygnDate).getDate() < 10
          ? "0" + new Date(sygnDate).getDate()
          : new Date(sygnDate).getDate());

      var body = {
        clientId: props.clientId,
        sygn: sygn,
        date:
          date +
          " " +
          new Date().getHours() +
          ":" +
          new Date().getMinutes() +
          ":" +
          new Date().getSeconds(),
        court: court,
        who: props.user,
        add: add,
      };

      await fetch("https://apidevkppp.ftpeople.pl/addSygnClient", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((data) => {})
        .catch((error) => {});

      props.logClientAction("Dodano sygnaturę i sąd", props.clientId);

      if (props.place === "task") {
        props.close();
      } else {
        MySwal.fire({
          icon: "success",
          title: "Dodano",
          text: "sygnaturę",
        }).then((result) => {
          props.close();
        });
      }
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
      });
    }
  };

  const validateSygn = () => {
    if (court.length > 0) {
      return true;
    }
    return false;
  };

  const handleCourtChange = (e) => {
    setCourt(e.value);
  };

  const createCourtOptions = (e) => {
    var bankOptions = [];
    bankOptions.push({
      label: "Do decyzji prawnika",
      value: "Do decyzji prawnika",
    });
    bankOptions.push({ label: "Brak", value: "Brak" });
    props.courtsData.map((el) => {
      bankOptions.push({ label: el.name, value: el.name });
    });

    return bankOptions;
  };

  return (
    <>
      <div className="mainContainerAddSygn">
        {loading ? (
          <Loading id="popUpLoading" />
        ) : (
          <>
            {props.place !== "task" ? (
              <>
                <div className="closeButtonAP">
                  <button className="closeClientButton" onClick={props.close}>
                    X
                  </button>
                </div>
              </>
            ) : (
              ""
            )}
            <div id="addPaymentIC" className="inputContainer">
              <div className="inputBox">
                <div className="inputCol_1">
                  <label>Sygnatura</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={sygn}
                    onChange={handleSygnChange}
                  />
                </div>
              </div>
              <div className="inputBox">
                <div className="inputCol_1">
                  <label>
                    Sąd <span className="requiredStar">*</span>
                  </label>
                  <Select
                    noOptionsMessage={() => "Brak danych"}
                    placeholder={"Wybierz..."}
                    isClearable={false}
                    options={courtOptions}
                    defaultValue={{ label: court, value: court }}
                    onChange={handleCourtChange}
                  />
                </div>
              </div>
              <div className="inputBox">
                <div className="inputCol_1">
                  <div
                    style={{
                      height: "2.5vh",
                      fontWeight: "300",
                      fontSize: "0.8vw",
                      width: "100%",
                    }}
                    className="checkBox"
                  >
                    <input
                      style={{ width: "10%", height: "2vh" }}
                      id="checkCal2"
                      type="checkbox"
                      checked={add}
                      onChange={(e) => {
                        setAdd(!add);
                      }}
                    />
                    Sygnatura poboczna
                  </div>
                </div>
              </div>
              <div className="inputBox">
                <div className="inputCol_1">
                  <label>
                    Obowiązuje od: <span className="requiredStar">*</span>
                  </label>
                  <input
                    type="date"
                    id="name"
                    name="name"
                    value={sygnDate}
                    onChange={handleSygnDateChange}
                  />
                </div>
              </div>
              <div className="saveBoxAP">
                <button className="paymentMenuButton" onClick={addSygn}>
                  zapisz
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default AddClientSygnPopup;
